import { logCustomDatadogAction } from "app/scripts/shared_setup"
import detectPlatform from "shared/detect_platform"

export default function FeaturedAppletsModule() {
  const tabs = document.querySelectorAll<HTMLButtonElement>(".featured-tab")
  const panels = document.querySelectorAll<HTMLDivElement>(".featured-category-panel")
  const cards = document.querySelectorAll<HTMLLIElement>(".featured-applet-card")

  tabs.forEach(tab => {
    tab.addEventListener("click", () => {
      const categorySlug = tab.dataset.category

      tabs.forEach(t => {
        t.classList.remove("active")
        t.setAttribute("aria-selected", "false")
      })
      tab.classList.add("active")
      tab.setAttribute("aria-selected", "true")

      panels.forEach(panel => {
        if (panel.dataset.category === categorySlug) {
          panel.classList.add("active")
          panel.setAttribute("aria-hidden", "false")
        } else {
          panel.classList.remove("active")
          panel.setAttribute("aria-hidden", "true")
        }
      })

      logCustomDatadogAction("featured_applets_tab_clicked", { category_name: categorySlug })
    })
  })

  const impressionObserver = new IntersectionObserver(
    entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting && entry.intersectionRatio >= 0.5) {
          const card = entry.target as HTMLLIElement

          if (card.dataset.impressionTracked === "false") {
            const appletId = card.dataset.appletId
            const categoryName = card.dataset.category

            logCustomDatadogAction("featured_applets_card_impression", {
              applet_id: appletId,
              category_name: categoryName,
              platform: detectPlatform(),
            })

            card.dataset.impressionTracked = "true"
          }
        }
      })
    },
    { threshold: 0.5 }
  )

  cards.forEach(card => impressionObserver.observe(card))

  cards.forEach(card => {
    card.addEventListener("click", () => {
      const appletId = card.dataset.appletId
      const categoryName = card.dataset.category

      logCustomDatadogAction("featured_applets_card_clicked", {
        applet_id: appletId,
        category_name: categoryName,
        platform: detectPlatform(),
      })
    })
  })

  const ctaButton = document.querySelector<HTMLAnchorElement>(".featured-cta")
  if (ctaButton) {
    ctaButton.addEventListener("click", () => {
      const activeTab = document.querySelector<HTMLButtonElement>(".featured-tab.active")
      const categoryName = activeTab ? activeTab.dataset.category : "unknown"

      logCustomDatadogAction("featured_applets_cta_clicked", { category_name: categoryName })
    })
  }
}
